import {gql} from '@apollo/client';

export const GET_MY_BALANCE = gql`
    query myBalance{
        myBalance{
            availableBalance{
                amount
                currency
            }
            pendingBalance{
                amount
                currency
            }
            reservedBalance{
                amount
                currency
            }
        }
    }
`

export const MY_WEEKLY_ORDER = gql`
    query myWeeklyOrder{
        myWeeklyOrder{
            totalOrdersThisWeek
            totalEstimatedEarningsThisWeek
        }
    }
`